<template>
  <div>
    <div class="wg-row">
      <div class="wg-col wg-xs-3" style="padding-top:10px;">
        <div class="icon-div">
          <img
            v-if="this.isDefaultImg"
            class="com-anm22-app-img-fixed-height-l links-img"
            :src="$anm22.icons.getWorldIcon('add')"
            @click="showInputImg = true"
            :title="$anm22.strLang(lang, 'Add url img', 'Aggiungi url immagine')"
          />
          <img
            v-else
            class="com-anm22-app-img-fixed-height-l links-img"
            :src="$anm22.icons.getWorldIcon(linkToAdd.img)"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-9">
        <div class="wg-row">
          <div class="wg-col wg-xs-9">
            <input
              class="input-text com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Add link...', 'Aggiungi link...')"
              type="text"
              v-model="linkToAdd.link"
              @keyup="checkImg()"
            />
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-6">
            <input
              class="input-text com-anm22-app-input-text"
              :placeholder="$anm22.strLang(lang, 'Add label...', 'Aggiungi etichetta...')"
              type="text"
              v-model="linkToAdd.label"
            />
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
        <template v-if="isDefaultImg && showInputImg">
          <div class="wg-row">
            <div class="wg-col wg-xs-9">
              <input
                class="input-text com-anm22-app-input-text"
                :placeholder="$anm22.strLang(lang, 'Add url img...', 'Aggiungi url immagine...')"
                type="text"
                v-model="linkToAdd.img"
                @change="checkImg()"
              />
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </template>
        <div class="wg-col wg-xs-3">
          <input
            type="button"
            :class="['small', linkToAdd.link == '' ? 'disabled' : '']"
            :disabled="linkToAdd.link == ''"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="updateAndSave"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    element: Object
  },
  data() {
    return {
      linkToAdd: {
        link: "",
        img: "",
        label: ""
      },
      links: [],
      isDefaultImg: true,
      showInputImg: false
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    })
  },
  methods: {
    checkImg() {
      let imgAndLabel = this.getImageAndLabelByUrl(this.linkToAdd.link);
      if (-1 == this.linkToAdd.img.indexOf("http")) {
        //Se l'immagine non è un url e non ci sono corrispondenze,il campo non sarà valido,altrimenti setterà l'immagine con la relativa icona trovata
        if (imgAndLabel.img == "") {
          this.isDefaultImg = true;
          this.linkToAdd.img = "";
        } else {
          this.isDefaultImg = false;
          this.showInputImg = false;
          this.linkToAdd.img = imgAndLabel.img;
        }
      } else {
        //Se l'immagine è un url ma ho trovato una corrispondenza nel sistema,allora l'immagine verrà automaticamente riconosciuta ,altrimenti sarà il link ad un immagine
        if (imgAndLabel.img != "") {
          this.isDefaultImg = false;
          this.showInputImg = false;
          this.linkToAdd.img = imgAndLabel.img;
        }
      }
    },
    updateAndSave() {
      //Check Http
      if (-1 == this.linkToAdd.link.indexOf("://")) {
        this.linkToAdd.link = "https://" + this.linkToAdd.link;
      }
      if (this.linkToAdd.label == "") {
        this.linkToAdd.label = this.getImageAndLabelByUrl(this.linkToAdd.link).label;
      }
      this.linkToAdd.creator = this.user.idWorldUser;
      this.links.push(this.linkToAdd);
      this.$emit("save", this.links);
    },
    getImageAndLabelByUrl(url) {
      if (-1 == url.indexOf("://")) {
        url = "https://" + url;
      }
      if (-1 !== url.search("://drive.google.com")) {
        return { img: "googleDrive", label: "Google Drive" };
      }
      if (-1 !== url.search("://www.ex.com")) {
        return { img: "xeLogo", label: "XE" };
      }
      if (-1 !== url.search("://mega.nz")) {
        return { img: "mega", label: "MEGA" };
      }
      if (-1 !== url.search("://www.dropbox.com")) {
        return { img: "dropbox", label: "Dropbox" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/tasks") ||
        -1 !== url.search("://tasks.anm22.it")
      ) {
        return { img: "menuTasksGreen", label: "ANM22 Tasks" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/contacts") ||
        -1 !== url.search("://contacts.anm22.it")
      ) {
        return { img: "menuContactsBlue", label: "ANM22 Contacts" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/calendar") ||
        -1 !== url.search("://calendar.anm22.it")
      ) {
        return { img: "menuCalendarRed", label: "ANM22 Calendar" };
      }
      if (-1 !== url.search("://www.anm22.it/app/work")) {
        return { img: "menuWork", label: "ANM22 Work" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/inbox") ||
        -1 !== url.search("://inbox.anm22.it")
      ) {
        return { img: "menuInbox", label: "ANM22 Inbox" };
      }
      if (-1 !== url.search("://resource.anm22.it")) {
        return { img: "menuResourceYellow", label: "ANM22 Resource" };
      }
      if (-1 !== url.search("slack.com")) {
        return { img: "slack", label: "Slack" };
      }
      if (-1 !== url.search("://www.icloud.com")) {
        return { img: "icloud", label: "iCloud" };
      }
      if (-1 !== url.search("://hangouts.google.com")) {
        return { img: "hangouts", label: "Hangouts" };
      }
      if (
        -1 !== url.search("://discord.gg") ||
        -1 !== url.search("://discordapp.com")
      ) {
        return { img: "discord", label: "Discord" };
      }
      if (-1 !== url.search("://join.skype.com")) {
        return { img: "skype", label: "Skype" };
      }
      if (-1 !== url.search("://docs.google.com/forms")) {
        return { img: "googleForms", label: "Google Forms" };
      }
      if (-1 !== url.search("://docs.google.com/presentation")) {
        return { img: "googleSlides", label: "Google Slides" };
      }
      if (-1 !== url.search("://docs.google.com/spreadsheets")) {
        return { img: "googleSheets", label: "Google Sheets" };
      }
      if (-1 !== url.search("://docs.google.com/document")) {
        return { img: "googleDocs", label: "Google Docs" };
      }
      if (-1 !== url.search("://meet.google.com")) {
        return { img: "googleMeet", label: "Google Meet" };
      }
      if (
        -1 !== url.search("://us04web.zoom.us") ||
        -1 !== url.search("://zoom.us")
      ) {
        return { img: "zoomLogo", label: "Zoom" };
      }
      if (-1 !== url.search("://teams.microsoft.com")) {
        return { img: "microsoftTeams", label: "Microsoft Teams" };
      }
      if (-1 !== url.search("://bitbucket.org")) {
        return { img: "bitbucket", label: "Bitbucket" };
      }
      if (-1 !== url.search("://github.com")) {
        return { img: "github", label: "GitHub" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/yourbeach") ||
        -1 !== url.search("://www.yourbeach.it/")
      ) {																		
        return { img: "yourbeachIcon", label: "YourBeach" };
      }
      if (
        -1 !== url.search("://www.anm22.it/app/food") ||
        -1 !== url.search("://www.yourfood.cloud")
      ) {
        return { img: "foodIcon", label: "YourFood" };
      }
      if (-1 !== url.search("://www.facebook.com/")) {
        return { img: "facebook", label: "Facebook" };
      }
      if (-1 !== url.search("://www.instagram.com/")) {
        return { img: "instagram", label: "Instagram" };
      }
      if (-1 !== url.search("://www.linkedin.com/")) {
        return { img: "linkedin", label: "Linkedin" };
      }
      if (-1 !== url.search("://twitter.com/")) {
        return { img: "twitter", label: "X" };
      }
      if (-1 !== url.search("://g.page/")) {
        return { img: "googleMyBusiness", label: "GoogleMyBusiness" };
      }
      if (-1 !== url.search("://www.youtube.com/")) {
        return { img: "youtube", label: "Youtube" };
      }
      if (-1 !== url.search("://m.me/")) {
        return { img: "messenger", label: "Messenger" };
      } 
      return { img: "", label: "" };
    }
  },
  created() {
    if (this.element.links.length > 0) {
      this.links = this.element.links;
    } else {
      this.links = [];
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-text {
  max-width: 100%;
}
.disabled {
  opacity: 0.6;
}
.links .icons {
  align-items: center;
  font-size: 0;
  padding: 10px;
}
.links-img {
  padding: 5px;
  height: 100%;
  width: 40px;
  object-fit: contain;
}
.icon-div {
  border-radius: 30px;
  width: 60px;
  height: 60px;
  background-color: #ddd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  cursor: pointer;
  margin: auto;
}
</style>
